import {Box, Text} from '@mantine/core';
import {useId} from '@mantine/hooks';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';

import HomepageBanner from './HomepageBanner';

const ANNOUNCEMENT_BANNER_TITLE = 'Message from your admin';

export default function HomepageAdminBanner(): JSX.Element {
  const titleId = useId();
  const messageId = useId();

  return (
    <Box mb="sm">
      <HomepageBanner color="blue" role="region" aria-labelledby={titleId} aria-describedby={messageId}>
        <Box fz="md">
          <Text weight={600} id={titleId}>
            {ANNOUNCEMENT_BANNER_TITLE}
          </Text>
          <Text id={messageId}>{BenchlingConfig.NAV_HOMEPAGE_ADMIN_BANNER}</Text>
        </Box>
      </HomepageBanner>
    </Box>
  );
}
